import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const callbackGuard: CanActivateFn = (
  route
): boolean | ReturnType<Router['createUrlTree']> => {
  const router = inject(Router);
  const hasCode = route.queryParamMap.has('code');
  const hasState = route.queryParamMap.has('state');

  if (hasCode && hasState) {
    return true;
  }

  const returnUrl = route.queryParamMap.get('returnUrl') || '/home';
  return router.createUrlTree(['/login'], { queryParams: { returnUrl } });
};
